<template>
  <ion-page>
    <ion-content>
      <div class="site-container">
        <header-section />
        <div class="main-content">
          <div class="left-content">
            <h2>Your Story</h2>
            <div class="profile" @click="$router.push('/story/read/create')">
              <div class="add-story">
                <span
                  ><i><svg-icon name="plus" /></i
                ></span>
              </div>
              <div class="story-description">
                <h3>Create a story</h3>
                <p>Share a photo or write something</p>
              </div>
            </div>

            <h4 class="title">All Stories</h4>

            <div class="stories-container">
              <div class="friend-story">
                <reed :stories="$store.state.stories"></reed>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import reed from "./allStories/reads.container.vue";
import SvgIcon from "../SvgIcon.vue";
import { IonContent, IonPage } from "@ionic/vue";
import HeaderSection from "../components/navBar/header.vue";
export default {
  components: {
    SvgIcon,
    reed,
    IonContent,
    IonPage,
    HeaderSection,
  },
  computed: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "./../styles/font-opensans.css";
@import "./../styles/font-fresca.css";
@import "./../styles/font-quicksand.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
body {
  font-family: "Open Sans", sans-serif;
  background: rgb(240, 240, 240);
}
.inner-row {
  width: 85%;
  margin: auto;
}
.profile-image {
  width: 2.7rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

header {
  top: 0;
  width: 100%;
  background: white;
  position: fixed;
  z-index: 889;
  height: 70px;
  box-shadow: 0px 1px 2px rgb(231, 231, 231);
}
header .inner-row {
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .logo-section {
  width: 50px;
  height: 50px;
}
.logo-section img {
  width: 135px;
}
.left-nav,
.right-nav {
  display: flex;
  align-items: center;
}

header .search-bar {
  background: whitesmoke;
  margin-left: 5%;
  width: 300px;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
}
.search-control {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Open Sans", sans-serif;
  color: #333;
}
.quick-links {
  margin-right: 5%;
  display: flex;
}
.quick-links .notify,
.quick-links .message {
  font-size: 1.5rem;
  cursor: pointer;
  color: rgb(80, 80, 80);
  position: relative;
}
.badge {
  position: absolute;
  top: 0;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background: rgb(235, 0, 0);
  box-shadow: 0px 0px 6px -1px rgb(250, 123, 123);
}
.badge span {
  font-size: 10px;
  font-weight: 600;
  color: white;
}
.profile-section {
  display: flex;
  align-items: center;
}
.profile-name {
  display: flex;
  align-items: center;
}
.profile-name h2 {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: rgb(80, 80, 80);
  font-family: "Quicksand";
  width: 100px;
}
.profile-name span {
  font-size: 1.2rem;
  cursor: pointer;
}

.mobile-navigation {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 889;
  display: none;
  justify-content: space-around;
  padding: 0.5rem 0;
  border-top: 1px solid gainsboro;
}
.mobile-nav-item a {
  color: #333;
}
.mobile-nav-item a span {
  display: flex;
}
.mobile-nav-item i {
  font-size: 1.3rem;
}
.mobile-nav-item {
  position: relative;
}
.mobile-nav-item router-link span {
  display: flex;
}

.mobile-sidebar {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: -100%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
}
.mobile-sidebar.active {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: 0;
}
.mobile-nav-link {
  display: block;
  line-height: 40px;
  color: #222;
  font-size: 0.9rem;
}

.mobile-profile {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
}
.mobile-profile .profile-text p {
  font-size: 0.7rem;
  color: #444;
}
.mobile-sidebar .logout {
  padding: 0.5rem 0;
  margin-top: 1rem;
  border-top: 1px solid gainsboro;
}
.mobile-sidebar .logout a {
  font-size: 0.9rem;
  color: #222;
}

.navTrigger {
  cursor: pointer;
  width: 30px;
  height: 25px;
  margin: auto;
  position: absolute;
  right: 20px;
  top: 20px;
  display: none;
  z-index: inherit;
}
.navTrigger i {
  background: #222;
  width: 100%;
  content: "";
  display: block;
  height: 4px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  -o-border-radius: 2px;
}
.navTrigger i:nth-child(1) {
  animation: outTp 0.8s backwards;
  -webkit-animation: outTp 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(2) {
  margin: 5px 0;
  animation: outMd 0.8s backwards;
  -webkit-animation: outMd 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(3) {
  animation: outBtm 0.8s backwards;
  -webkit-animation: outBtm 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger.active i:nth-child(1) {
  -webkit-animation: inTp 0.8s forwards;
  animation: inTp 0.8s forwards;
}

.navTrigger.active i:nth-child(2) {
  -webkit-animation: inMd 0.8s forwards;
  animation: inMd 0.8s forwards;
}

.navTrigger.active i:nth-child(3) {
  -webkit-animation: inBtm 0.8s forwards;
  animation: inBtm 0.8s forwards;
}
/*Keyframes*/
@keyframes inMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes outMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes inTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes outTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

.create-modal-popup {
  position: fixed;
  top: 0;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.86);
  z-index: 999;
  display: none;
  justify-content: center;
  align-items: center;
}
.create-modal-popup .modal-content {
  width: 450px;
  border-radius: 0.5rem;
  max-height: 600px;
  background-color: #fff;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  box-shadow: 0px 0px 2px 1px rgb(211, 211, 211);
  overflow-y: scroll;
  // position:relative;
  scrollbar-width: none;
}
.modal-content .modal-header {
  text-align: center;
  position: relative;
  padding: 0.8rem 0;
  border-bottom: 1px solid gainsboro;
  margin-bottom: 0.5rem;
}
.modal-header h3 {
  font-size: 1.2rem;
}
.modal-header .cancel {
  position: absolute;
  right: 0.2rem;
  cursor: pointer;
  top: 10px;
}
.modal-header .cancel i {
  font-size: 1.5rem;
}

.modal-body {
  padding: 0.5rem 1rem;
}
.modal-body .modal-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
}

.textarea-control {
  font-family: "Quicksand";
  font-size: 1rem;
  border: none;
  outline: none;
  padding-left: 0.2rem;
  width: 100%;
  resize: none;
}

.file-preview {
  width: 100%;
  height: 300px;
  margin: 1rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: none;
}
.file-preview img {
  object-fit: cover;
  display: none;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
::-webkit-scrollbar {
  width: 0;
}
.additions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding:0.8rem 0.5rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}
.addition {
  border: 1px solid rgb(182, 180, 180);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 0.5rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}
.additions h2 {
  font-size: 1rem;
  color: #444;
  font-weight: 500;
}
.additions .upload {
  width: 100%;
  /* height: 25px; */
  cursor: pointer;
}
.addition .upload {
  width: fit-content;
  height: 25px;
  /* cursor: pointer; */
  display: flex;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
}

.post-submit {
  width: 100%;
  display: block;
  padding: 0.8rem 0;
  font-family: "Quicksand";
  font-size: 0.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: white;
  background: rgb(0, 110, 255);
  border: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  cursor: pointer;
}
.zoomIn {
  animation: zoomIn 0.5s ease-in;
  -webkit-animation: zoomIn 0.5s ease-in;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.tag-body {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: white;
  display: none;
}

.poll-body {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: white;
  display: none;
}
.post-progress-body {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: white;
  display: none;
}

.post-progress-body span {
  position: fixed;

  justify-content: center;
  align-items: center;
  top: 50%;
  left: 45%;
  right: 45%;
}

.tag-title {
  padding: 0.7rem;
  display: flex;
  gap: 7rem;
  align-items: center;
  border-bottom: 1px solid gainsboro;
  position: sticky;
  top: 0;
  background-color: white;
}
.tag-title span {
  font-size: 25px;
  cursor: pointer;
  background-color: rgb(247, 247, 247);
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.tag-title span:hover {
  background-color: gainsboro;
  transition: all 1s linear;
  -webkit-transition: all 1s linear;
  -moz-transition: all 1s linear;
  -ms-transition: all 1s linear;
  -o-transition: all 1s linear;
}

.tag-title h2 {
  font-size: 1.5rem;
}

.tag-search {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
}
.search-box {
  background-color: rgb(235, 234, 234);
  width: 80%;
  padding: 0.4em;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  display: flex;
  gap: 0.5rem;
}
.search-box .search-friends {
  border: none;
  background: transparent;
  outline: none;
  font-family: "Quicksand";
  width: 100%;
}
.tag-search button {
  background: transparent;
  font-family: "Quicksand";
  border: none;
  font-weight: 600;
  color: rgb(0, 110, 255);
  cursor: pointer;
}

.suggestions {
  width: 90%;
  margin: auto;
  height: 400px;
  overflow-y: scroll;
  scrollbar-width: none;
}

.tag-body h3 {
  width: 90%;
  margin: 0 auto 0.5rem auto;
  font-size: 1rem;
}
.suggestions .friend {
  display: flex;
  margin-bottom: 1rem;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
}

.suggestions .friend-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

// ::-webkit-scrollbar {
//       width: 0;
//   }
.main-wrapper {
  position: relative;
  top: 6rem;
}

.main-wrapper .inner-row {
  display: grid;
  grid-template-columns: 20vw auto 22vw auto;
  column-gap: 30px;
}
.sidebar {
  position: sticky;
  top: 6rem;
  background: #fff;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
}
.sidebar .nav-link {
  display: flex;
  align-items: center;
  height: 3rem;
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -moz-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  position: relative;
}
.sidebar .nav-link:hover {
  background: rgb(247, 250, 252);
}
.sidebar .nav-link i {
  font-size: 1.5rem;
  margin-left: 1.5rem;
  color: rgb(92, 92, 92);
}
.sidebar .nav-link span {
  color: #333;
  position: relative;
  display: flex;
}
.sidebar .nav-link span.badge {
  right: 5px;
}
.sidebar .nav-link .badge span {
  color: #fff !important;
}
.nav-link.active {
  background: rgb(247, 250, 252);
}
.nav-link.active span,
.nav-link.active i {
  color: rgb(0, 110, 255);
}

.nav-link.active::before,
.nav-link:hover::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  width: 0.3rem;
  height: 100%;
  background: rgb(0, 110, 255);
}
.nav-link:first-child.active {
  border-top-left-radius: 0.5rem;
  overflow: hidden;
}
.nav-link:last-child.active,
.nav-link:last-child:hover {
  border-bottom-left-radius: 0.5rem;
  overflow: hidden;
}

.middle-container .reads {
  display: flex;
  justify-content: space-between;
  height: 10rem;
  gap: 0.5rem;
}
.reads .read {
  padding: 1rem;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 0.75rem;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.reads .read .profile-image {
  border: 2px solid rgba(0, 110, 255, 0.582);
  width: 2rem;
  height: 2rem;
  align-self: start;
}
.reads .read::before {
  content: "";
  display: block;
  width: 100%;
  height: 5rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
  position: absolute;
  bottom: 0;
  z-index: 1;
}
.read .name {
  z-index: 2;
}
.reads .read:nth-child(1) {
  background: url("https://hyreads.com/images/read-bg1.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(2) {
  background: url("https://hyreads.com/images/read-bg2.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(3) {
  background: url("https://hyreads.com/images/read-bg3.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(4) {
  background: url("https://hyreads.com/images/read-bg4.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(5) {
  background: url("https://hyreads.com/images/read-bg5.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(6) {
  background: url("https://hyreads.com/images/read-bg6.jpg") no-repeat center
    center/cover;
}

.btn-post {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  cursor: pointer;
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -moz-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  font-size: 0.8rem;
  border: none;
  font-family: "Open Sans", sans-serif;
  background: rgb(0, 110, 255);
  color: #fff;
}
.btn-post:hover {
  opacity: 0.8;
}
.create-post {
  margin: 1rem 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: white;
  padding: 0.4rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  cursor: pointer;
}
.create-post input[type="text"] {
  justify-self: start;
  width: 100%;
  padding-left: 0.5rem;
  margin: 0 1rem 0 0.2rem;
  border: none;
  outline: none;
  font-family: "Open Sans", sans-serif;
}

/* -------Posts------*/
.middle-container .posts .post {
  background: #fff;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  padding: 1rem;
  margin: 1rem 0;
  font-size: 0.85rem;
  line-height: 1.3rem;
}

.posts .post-head {
  display: flex;
  justify-content: space-between;
}
.post-head .user {
  display: flex;
  gap: 1rem;
}
.post-head .namlo {
  color: #333;
}
.namlo h3 {
  font-size: 1rem;
  font-weight: 600;
}
.post-head span {
  cursor: pointer;
}
.post .post-photo {
  overflow: hidden;
  margin: 0.7rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
.post .sentence-post,
.post .video-post {
  margin: 1rem 0;
}
.post .action-btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.3rem;
  margin: 0.5rem;
}
.action-btns span {
  cursor: pointer;
  position: relative;
}
.action-btns .interaction-btns {
  display: flex;
  align-items: center;
  padding-left: 35px;
  gap: 12px;
}

.post .people-likings {
  display: flex;
}
.people-likings span {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  border: 2px solid gainsboro;
  margin-left: -0.6rem;
}
.people-likings span:first-child {
  margin: 0;
}
.people-likings p {
  margin-left: 0.5rem;
}

.caption {
  margin: 0.3rem 0;
  color: #333;
  text-align: justify;
}
.comments {
  color: gray;
  cursor: pointer;
}

.comments-list {
  margin-top: 1rem;
}
.comments-list .comment {
  display: grid;
  grid-template-columns: 40px 90%;
}
.comment .profile-image {
  width: 30px;
  height: 30px;
}
.comment .comment-body {
  background: rgb(241, 241, 241);
  padding: 0.5rem;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
.comment .comment-body h5 {
  font-size: 0.8rem;
  font-weight: 600;
}
.comment .comment-body p {
  font-size: 0.6rem;
}
.create-comment {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
}
.create-comment .profile-image {
  width: 30px;
  height: 30px;
}
.input-comment {
  width: 85%;
}
.input-comment .comment-control {
  height: 40px;
  width: 100%;
  padding: 0.5rem;
  font-family: "Quicksand";
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  background-color: #ddd;
  border: none;
  outline: none;
  resize: none;
  color: #333;
}
.comment-control::placeholder {
  font-size: 0.8rem;
}
.create-comment span {
  font-size: 30px;
  color: rgb(0, 110, 255);
  cursor: pointer;
}

.right-container {
  height: max-content;
  position: sticky;
  top: 6rem;
}

.right-container .messages {
  background: #fff;
  padding: 1rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
}
.messages .title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  align-items: center;
}
.messages .title i {
  font-size: 1.3rem;
}

.messages .search-bar {
  width: 100%;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
  background: whitesmoke;
  margin-bottom: 1rem;
}
.messages .search-bar #message-search {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Open Sans", sans-serif;
  color: #333;
}

.messages .category {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.messages .category h5 {
  width: 100%;
  text-align: center;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgb(196, 196, 196);
  font-size: 0.85rem;
  cursor: pointer;
}
.messages .category .active {
  border-color: royalblue;
}
.messages .message {
  display: flex;
  gap: 0.6em;
  margin-bottom: 1rem;
  align-items: center;
}
.messages .message:last-child {
  margin: 0;
}

.messages .message p {
  font-size: 0.8rem;
}
.message .profile-image {
  position: relative;
  overflow: visible;
}
.message .profile-image img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.message .profile-image .active {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background: rgb(0, 255, 0);
  position: absolute;
  bottom: 0.1rem;
  right: 0;
}

.right-container .friend-requests {
  margin-top: 1rem;
}
.friend-requests h4 {
  color: #333;
  margin: 1rem 0;
}
.friend-requests .request {
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  background: white;
  padding: 1rem;
  margin-bottom: 1rem;
}
.request .info {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
}
.request .info p {
  font-size: 0.75rem;
  color: #444;
}
.tendo-btns {
  display: flex;
  gap: 1rem;
}
.tendo-btns .btn {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  cursor: pointer;
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -moz-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  font-size: 0.8rem;
  border: none;
  font-family: "Open Sans", sans-serif;
  color: #fff;
}
.tendo-btns .btn-accept {
  background: rgb(0, 110, 255);
}
.tendo-btns .btn-decline {
  background: rgba(255, 0, 0, 0.616);
}

/*=======Responsivity=========*/
@media (max-width: 1200px) {
  .inner-row {
    width: 95%;
  }

  .main-wrapper .inner-row {
    grid-template-columns: 4rem auto 30vw;
    gap: 1rem;
  }
  .sidebar {
    width: 4rem;
  }
  .sidebar span {
    display: none;
  }
  .sidebar .nav-link i {
    margin-left: 1rem;
  }
}

@media (max-width: 930px) {
  .right-container {
    display: none;
  }
  .main-wrapper .inner-row {
    grid-template-columns: 4rem auto;
    gap: 1rem;
  }
}
@media (max-width: 700px) {
  .navTrigger {
    display: block;
  }
  .middle-container {
    width: 100%;
    display: block;
    margin-bottom: 9rem;
  }
  .main-wrapper .inner-row {
    grid-template-columns: repeat(1, 1fr);
    display: block;
  }
  header .search-bar,
  .right-nav,
  .sidebar {
    display: none;
  }
  .mobile-navigation {
    display: flex;
  }
}
select {
  /* Reset Select */
  appearance: none;
  outline: 0;
  border: 0;
  box-shadow: none;
  /* Personalize */
  flex: 1;
  padding: 0 1em;
  /* color: #fff; */
  /* background-color: #34495e; */
  background-image: none;
  cursor: pointer;
  width: 50%;
  margin-top: 10px;
}
/* Remove IE arrow */
select::-ms-expand {
  display: none;
}
/* Custom Select wrapper */
.select {
  position: relative;
  display: flex;
  width: 100%;
  /* height: 3em; */
  border-radius: 0.25em;
  overflow: hidden;
}
/* Arrow */
.select::after {
  content: "\25BC";
  position: absolute;
  top: 13px;
  left: 75px;
  /* padding: 1em; */
  /* background-color: #34495e; */
  transition: 0.25s all ease;
  pointer-events: none;
  font-size: 12px;
}
/* Transition */
.select:hover::after {
  color: #030303;
}
.vac-media-container {
  z-index: -1;
}
.vac-icon-media {
  display: flex;
  justify-content: flex-end;
  position: absolute;

  // justify-content:flex-end;
  z-index: 10;

  svg {
    height: 30px;
    width: 30px;
    border-radius: 50%;
  }

  &:before {
    content: " ";
    position: absolute;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
  }
}
.vac-media-file {
  width: 100%;
  height: 100%;
  max-height: 300px;
  overflow: scroll;
  margin: 1rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: grid;
  grid-template-columns: auto auto auto auto;

  img {
    border-radius: 15px;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  video {
    border-radius: 15px;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
em {
  font-style: normal;
}
.router-link-exact-active.menuItem-active-link {
  fill: rgb(0, 110, 255);
  //     text-decoration-line:underline;
}

.router-link-exact-active.menuItem-active-link:hover {
  fill: rgb(0, 110, 255);
  //     text-decoration-line:underline;
}

.invite-moja {
  margin-bottom: 20px;
}
.invite-moja,
.invite-moja .moja-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.invite-moja .moja-right i {
  font-size: 22px;
  cursor: pointer;
}
.moja-right i:nth-child(1) {
  color: red;
}
.moja-right i:nth-child(2) {
  color: green;
}

.invite-moja .moja-left {
  display: flex;
  gap: 5px;
}
.moja-left h4 {
  font-size: 1rem;
}
.invite-moja .invite-image img {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}

.text {
  overflow: hidden;
  width: 240px;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 16px;
  max-height: 20px;
}

.search-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 999;
  padding: 50px 20px;
  overflow-y: scroll;
  display: none;
}

.search-container .inner-row {
  position: relative;
}
::-webkit-scrollbar {
  height: 0;
}

.search-container h2 {
  text-transform: uppercase;
  font-weight: 100;
  font-size: 15px;
  margin-bottom: 10px;
}
.search-container .style-form-ya-search {
  width: 90%;
  height: 40px;
  border: none;
  border-radius: 45px;
  -webkit-border-radius: 45px;
  -moz-border-radius: 45px;
  -ms-border-radius: 45px;
  -o-border-radius: 45px;
  outline: none;
  padding: 0 10px;
  font-size: 15px;
  font-family: "Quicksand";
  background: rgba(240, 247, 255, 0.74);
  border: 1px solid rgb(232, 242, 255);
}
.search-container .form-row button {
  background: transparent;
  border: none;
}
.search-container .form-row button i {
  font-size: 20px;
  cursor: pointer;
}
.users-container h3,
.posts-container h3 {
  margin: 10px 0;
  font-size: 16px;
}
.users-container h4 {
  font-size: 16px;
}

.profile-ya-mtu {
  display: flex;
  gap: 5px;
  align-items: center;
  margin-bottom: 10px;
}

.post-moja {
  border: 1px solid gainsboro;
  padding: 20px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  background: #fff;
  margin-bottom: 10px;
}
.post-moja .post-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.post-header .left-side {
  display: flex;
  gap: 5px;
}
.post-header h4 {
  font-size: 16px;
}
.post-header p {
  font-size: 13px;
}
.post-header .right-side i {
  font-size: 20px;
}

.post-moja .post-image {
  margin: 10px 0;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  overflow: hidden;
}
.times-btn {
  position: absolute;
  top: -20px;
  right: 0;
}
.times-btn i {
  font-size: 25px;
  cursor: pointer;
}

input.hide-clear[type="search"]::-webkit-search-decoration,
input.hide-clear[type="search"]::-webkit-search-cancel-button,
input.hide-clear[type="search"]::-webkit-search-results-button,
input.hide-clear[type="search"]::-webkit-search-results-decoration {
  display: none;
}

.main-content {
  position: relative;
  top: 70px;
}
.main-content .left-content {
  width: 100%;
  position: fixed;
  left: 0;
  top: 70px;
  bottom: 0;
  background: white;
  padding: 1rem;
  overflow-y: scroll;
}
.left-content h2 {
  font-size: 1.5rem;
  margin: 1rem 0;
}
.left-content .profile {
  display: flex;
  gap: 1rem;
  align-items: center;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid gainsboro;
}
.profile h3 {
  font-weight: 400;
}
.main-content .right-content {
  margin-left: 350px;
  height: 88vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.right-content .content-inner {
  width: 60%;
  display: flex;
  justify-content: space-around;
  gap: 1rem;
}
.right-content .upload-box,
.right-content .text-box {
  text-align: center;
  width: 200px;
  height: 200px;
  box-shadow: 0px 0px 1px 1px rgb(179, 179, 179);
  cursor: pointer;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-content span {
  font-size: 1.8rem;
  display: block;
  margin-bottom: 20px;
}
.right-content h3 {
  font-size: 1rem;
  color: #333;
}

.create-text-story-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.884);
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
}

.story-content {
  width: 500px;
  height: 400px;
  background-color: white;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding: 1rem;
  box-shadow: 0px 0px 3px 1px gainsboro;
}

.story-title {
  text-align: center;
  padding: 0.8rem 0;
  border-bottom: 1px solid gainsboro;
  margin-bottom: 1rem;
  position: relative;
}
.story-title h2 {
  font-size: 1.2rem;
  color: #333;
}
.story-title span {
  position: absolute;
  right: -10px;
  top: -10px;
  font-size: 1.5rem;
  cursor: pointer;
}
.story-body .text-area {
  font-size: 1rem;
  font-family: "Quicksand";
  padding: 0.5rem;
  width: 100%;
  outline: none;
  height: 150px;
  border: none;
}
.color-pallet {
  display: flex;
  margin: 0.5rem 0;
  justify-content: space-between;
}
.color-pallet .color-box {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  cursor: pointer;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.color-box.current-color {
  box-shadow: 0px 0px 3px 3px rgb(201, 201, 201);
}
.color-box.red {
  background-color: red;
}
.color-box.green {
  background-color: green;
}
.color-box.violet {
  background-color: violet;
}
.color-box.orange {
  background-color: orange;
}
.color-box.blue {
  background: blue;
}
.color-box.black {
  background: black;
}
.color-box.indigo {
  background: indigo;
}
.color-box.yellow {
  background: yellow;
}
.color-box.white {
  border: 1px solid gainsboro;
}
.story-content p {
  font-size: 14px;
}

.story-content button {
  display: block;
  background: blue;
  width: 100%;
  margin-top: 1.2rem;
  height: 45px;
  border: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  font-size: 14px;
  font-family: "Quicksand";
  color: white;
  cursor: pointer;
}
@media (max-width: 930px) {
  .right-content .content-inner {
    width: 80%;
    display: block;
  }
  .right-content .upload-box,
  .right-content .text-box {
    width: 100%;
  }
}
@media (max-width: 600px) {
  .story-content {
    width: 90%;
  }
}

.add-story {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dddddd;
  cursor: pointer;
}
.add-story span {
  font-size: 1.3rem;
  color: blue;
}
.story-description p {
  font-size: 12px;
}

.left-content .title {
  margin: 1rem 0;
}

.friend-story {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.friend-story .profile-image {
  border: 2px solid blue;
}
.story-meta p {
  font-size: 12px;
  color: gray;
}
.mobile-navigation {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  display: none;
  justify-content: space-around;
  padding: 0.5rem 0;
  border-top: 1px solid gainsboro;
}
.mobile-nav-item a {
  color: #333;
}
.mobile-nav-item i {
  font-size: 1.3rem;
}

.mobile-sidebar {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: -100%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
}
.mobile-sidebar.active {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: 0;
}
.mobile-nav-link {
  display: block;
  line-height: 40px;
  color: #222;
  font-size: 0.9rem;
}

.mobile-profile {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
}
.mobile-profile .profile-text p {
  font-size: 0.7rem;
  color: #444;
}
.mobile-sidebar .logout {
  padding: 0.5rem 0;
  margin-top: 1rem;
  border-top: 1px solid gainsboro;
}
.mobile-sidebar .logout a {
  font-size: 0.9rem;
  color: #222;
}
</style>
